import { Alert, Box, Snackbar, Tab, Tabs, useTheme } from "@mui/material";
import { useEffect, useMemo, useState, useRef } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useNavigationType,
  useOutletContext,
  useParams,
} from "react-router-dom";
import useStyles from "./styles";
import api from "../../../services/api";
import Home from "../home";
import CadastroCliente from "../forms/cadastro";
import ModalCriarGrupo from "../forms/grupoEconomico";
import scrollClicker from "../../../utils/scrollClicker";
import InternoModalConfirmacaoSaida from "../../../components/modalSaindoDaPagina";
import PerfilFilter from "./filter";
import { getErpPrincipal, temErp } from "../../../services/erpSistema";

export const parsePerfilUrlParams = (pathname) => {
  const parts = (pathname || "").split("/").filter(Boolean);
  const perfilIndex = parts.indexOf("perfil");
  if (perfilIndex === -1 || perfilIndex === parts.length - 1) {
    return { tab: null, clienteId: null, serviceId: null };
  }

  const nextPart = parts[perfilIndex + 1];
  const SERVICE_URL_TABS = [
    "servicos",
    "config",
    "circuito",
    "remoteAccess",
    "flow",
  ];

  if (SERVICE_URL_TABS.includes(nextPart)) {
    const remaining = parts.slice(perfilIndex + 2);
    if (remaining.length >= 2) {
      // Formato: /perfil/tab/:serviceId/:clienteId
      return {
        tab: nextPart,
        serviceId: remaining[0],
        clienteId: remaining[1],
      };
    } else if (remaining.length === 1) {
      // Formato: /perfil/tab/:clienteId
      return {
        tab: nextPart,
        serviceId: null,
        clienteId: remaining[0],
      };
    } else {
      return { tab: nextPart, clienteId: null, serviceId: null };
    }
  } else {
    // Formato: /perfil/:clienteId
    return {
      tab: null,
      clienteId: nextPart,
      serviceId: null,
    };
  }
};

export default function Perfil({ routesPermissao, admPermissao }) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const navigationType = useNavigationType();
  const [snackbar, setSnackbar] = useState(null);
  const id = useParams();
  const [value, setValue] = useState(0);
  const [clientes, setClientes] = useState([]);
  const [buscarUsuario, setBuscarUsuario] = useState("");
  const [selectedCliente, setSelectedCliente] = useState(null);

  const [allServices, setAllServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [urlServiceId, setUrlServiceId] = useState(() => parsePerfilUrlParams(window.location.pathname).serviceId);
  const previousClienteIdRef = useRef(null);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalCriarGrupo, setOpenModalCriarGrupo] = useState(false);
  const [windowWith, setWindowWith] = useState(window.innerWidth);
  const [openFilter, setOpenFilter] = useState(false);
  const [versaoClientes, setVersaoClientes] = useState(0);
  const [changed, setChanged] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [serviceFilter, setServiceFilter] = useState(null);
  const [services, setServices] = useState([]);
  const [showCanceled, setShowCanceled] = useState(false);
  //////////////////////////////////////////////////
  const [allService, setAllService] = useState([]);
  const [selectService, setSelectService] = useState({});
  const [selectStatus, setSelectStatus] = useState({});
  const [searchAutocomplete, setSearchAutocomplete] = useState("");
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const [options, setOptions] = useState([]);
  const [statusFilter, setStatusFilter] = useState("todos");
  const [configStatusFilter, setConfigStatusFilter] = useState("");

  // States de Sincronização de ONUs
  const [syncRunning, setSyncRunning] = useState(false);
  const [syncRefreshTrigger, setSyncRefreshTrigger] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const syncPollingRef = useRef(null);

  const [paramsSearchCliente, setParamsSearchCliente] = useState({
    params: "",
    typeSearch: Number(localStorage.getItem("typeSearch")) || 1,
  });

  const [selectedTagFilter, setSelectedTagFilter] = useState(null);
  // null = sem filtro; 0 = PJ; 1 = PF.
  const [tipoClienteFilter, setTipoClienteFilter] = useState(null);
  // ERPs cadastrados (filtro da lista). null no filtro = todos.
  const [erps, setErps] = useState([]);
  const [erpFilter, setErpFilter] = useState(null);
  const [availableTags, setAvailableTags] = useState([]);

  // States Acesso Remoto
  const [allHostsCliente, setAllHostsCliente] = useState([]);
  const [selectedHost, setSelectedHost] = useState(null);

  useEffect(() => {
    if (paramsSearchCliente?.typeSearch) {
      localStorage.setItem("typeSearch", paramsSearchCliente?.typeSearch);
    }
  }, [paramsSearchCliente?.typeSearch]);

  // ERP do sistema (busca global de clientes, que ainda usa a variável ERP do
  // backend): com HubSoft cadastrado vale o padrão HubSoft.
  const erp = temErp("HUBSOFT") ? "HUBSOFT" : getErpPrincipal();

  // ERP do cliente aberto: decide textos, componentes e payloads das abas.
  // Grupo econômico (sem ERP próprio): o dos membros se todos forem do mesmo
  // tipo; misturado, padrão HubSoft. Sem cliente/ERP: o do sistema.
  const tipoDoErpId = (erpId) => erps.find((item) => item.id === erpId)?.tipo;
  const erpDoCliente = (cliente) => {
    const proprio = cliente?.erp?.tipo || tipoDoErpId(cliente?.erpId);
    if (proprio) return proprio;
    const tipos = [
      ...new Set(
        (cliente?.membros || [])
          .map((membro) => tipoDoErpId(membro?.erpId))
          .filter(Boolean),
      ),
    ];
    if (tipos.length === 1) return tipos[0];
    if (tipos.includes("HUBSOFT")) return "HUBSOFT";
    return tipos[0] || erp;
  };
  const erpCliente = erpDoCliente(selectedCliente);
  const labelErp =
    erpCliente === "HUBSOFT"
      ? "Serviço"
      : erpCliente === "VOALLE"
        ? "Contrato"
        : erpCliente === "IXC"
          ? "Contrato"
          : erpCliente === "VERO"
            ? "Contrato"
            : "Serviço";

  const navigate = useNavigate();
  const { controllerDashboard, setControllerDashboard } = useOutletContext();

  const configErp = {
    HUBSOFT: "serviço",
    VOALLE: "contrato",
    IXC: "contrato",
  };

  useEffect(() => {
    //Funções a serem executadas ao carregar a página
    apiGetClientes();
    api
      .get("/interno/configErp/erpsSistema")
      .then((response) => setErps(response?.data || []))
      .catch((error) => console.error(error));

    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => clearInterval(syncPollingRef.current);
  }, []);

  useEffect(() => {
    api.post("/interno/findMany/tagsCircuito", { type: "clienteGrupo" })
      .then(res => setAvailableTags(res.data || []))
      .catch(err => console.error("Erro ao buscar tags globais", err));
  }, []);

  // Inicia o polling a cada 30 segundos
  const startSyncPolling = () => {
    if (syncPollingRef.current) clearInterval(syncPollingRef.current);
    syncPollingRef.current = setInterval(async () => {
      try {
        const res = await api.get("/force/updateHosts/status");
        if (!res?.data?.running) {
          setSyncRunning(false);
          clearInterval(syncPollingRef.current);

          // Atualiza os dados da tela diretamente e mostra mensagem de sucesso temporária
          setSyncRefreshTrigger(true);
          setSnackbar({
            children: "Sincronização concluída (todos os clientes)",
            severity: "success",
          });
        }
      } catch (_) {
        // Ignora erros para não interromper UX
      }
    }, 10000);
  };

  // Dispara a sincronização manual de ONUs
  const handleForceSync = async () => {
    if (syncRunning) return;
    try {
      const response = await api.post("/force/updateHosts");
      setSnackbar({
        children:
          response?.data?.message ||
          "Sincronização iniciada (todos os clientes)",
        severity: "success",
      });
      setSyncRunning(true);
      startSyncPolling();
    } catch (error) {
      const isConflict = error?.response?.status === 409;
      setSnackbar({
        children: isConflict
          ? "A sincronização já está em execução. Aguarde a conclusão."
          : "Erro ao iniciar sincronização de ONUs.",
        severity: isConflict ? "warning" : "error",
      });
      if (isConflict) {
        setSyncRunning(true);
        startSyncPolling();
      }
    }
  };

  // Abas que suportam o parâmetro :serviceId na URL
  const SERVICE_URL_TABS = ["servicos", "config", "circuito", "remoteAccess"];

  const handleSetSelectedService = (service) => {
    setSelectedService(service);
    const sid = service ? (service?.id_cliente_servico ?? service?.id) : null;
    setUrlServiceId(sid);
  };

  const filterServiceId = selectedService?.id_cliente_servico ?? selectedService?.id;
  const effectiveServiceId = filterServiceId ?? urlServiceId;

  const buildTabPath = (tabSegment) =>
    effectiveServiceId
      ? `/interno/home/perfil/${tabSegment}/${effectiveServiceId}/${selectedCliente?.id}`
      : `/interno/home/perfil/${tabSegment}/${selectedCliente?.id}`;

  const navPages = useMemo(
    () => [
      {
        match: "/interno/home/perfil/servicos",
        path: buildTabPath("servicos"),
      },
      {
        match: "/interno/home/perfil/config",
        path: buildTabPath("config"),
      },
      {
        match: "/interno/home/perfil/circuito",
        path: buildTabPath("circuito"),
      },
      {
        match: "/interno/home/perfil/remoteAccess",
        path: buildTabPath("remoteAccess"),
      },
      {
        match: "/interno/home/perfil/flow",
        path: `/interno/home/perfil/flow/${selectedCliente?.id}`,
      },
      {
        match: "/interno/home/perfil/",
        path: `/interno/home/perfil/${selectedCliente?.id}`,
      },
    ],
    [selectedCliente?.id, effectiveServiceId], // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    if (
      searchAutocomplete?.length > 0 &&
      (paramsSearchCliente?.typeSearch === 2 ||
        paramsSearchCliente?.typeSearch === 4 ||
        paramsSearchCliente?.typeSearch === 5)
    ) {
      searchClientes();
    }
  }, [searchAutocomplete]);

  const statusOptionsUnique = Array?.from(
    new Set(allService?.map((service) => service?.status)),
  ).map((status) => ({ status }));

  // Uso de api para receber a lista de clientes
  async function apiGetClientes() {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    try {
      const response = await api.get("/interno/getClients", { signal });

      setClientes(response.data);

      const { clienteId: urlClienteId } = parsePerfilUrlParams(
        window.location.pathname,
      );

      const clienteEncontrado = response?.data?.find(
        (cliente) => cliente?.id === urlClienteId,
      );

      if (clienteEncontrado) {
        setSelectedCliente(clienteEncontrado || null);

        let existingData = {};
        try {
          existingData = JSON.parse(localStorage.getItem("filterData")) || {};
        } catch (e) { }

        const clientStorage = {
          interfaceId: existingData?.interfaceId || "",
          clienteId: clienteEncontrado?.id,
          hostId: existingData?.hostId || "",
          selectTime: existingData?.selectTime || 5,
          initialDate: existingData?.initialDate || "",
          finalDate: existingData?.finalDate || "",
          ...(existingData?.clienteId === clienteEncontrado?.id &&
            existingData?.serviceId
            ? { serviceId: existingData?.serviceId }
            : {}),
        };

        localStorage.setItem("filterData", JSON.stringify(clientStorage));
        return;
      }

      const selectedClientStorage = JSON.parse(
        localStorage.getItem("filterData"),
      );
      if (selectedClientStorage && !clienteEncontrado) {
        const selectClient = response?.data?.find(
          (cliente) => cliente?.id === selectedClientStorage?.clienteId,
        );
        setSelectedCliente(selectClient);
        return;
      }

      if (!clienteEncontrado && window.location.pathname.includes("perfil")) {
        navigate(`/interno/home/perfil`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  function handleNewClient(newClient) {
    let newArray = [...clientes];
    newArray.push(newClient);
    setClientes(newArray);
    setVersaoClientes((v) => v + 1);
  }

  //Change tabs handler
  const handleChange = (event, newValue) => {
    navigate(navPages[newValue].path);
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleOpenAutocomplete = () => {
    setOpenAutocomplete(true);
  };
  const handleCloseAutocomplete = () => {
    setOpenAutocomplete(false);
    setOptions([]);
    setSearchAutocomplete("");
  };

  const searchClientes = async () => {
    if (!searchAutocomplete) return;

    try {
      setLoadingAutocomplete(true);
      const response = await api.post("/interno/find/clienteForService", {
        search: searchAutocomplete?.trim(),
        typeSearch: paramsSearchCliente.typeSearch,
      });
      setOptions(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingAutocomplete(false);
    }
  };

  function handleUsuarioId() {
    let result = JSON.parse(localStorage.getItem("user"));

    if (Array.isArray(result?.usuario?.rlPermissoesUsuario)) {
      for (let permissao of result?.usuario?.rlPermissoesUsuario) {
        if (permissao?.permissao?.codigoPermissao.toUpperCase() === "ADM") {
          return true;
        }
      }
    }

    return false;
  }

  // Função para encontrar a primeira rota que o usuário tem acesso
  const getFirstAllowedRoute = (clienteId) => {
    if (admPermissao || routesPermissao[navPages[0].match])
      return `/interno/home/perfil/servicos/${clienteId}`;
    if (admPermissao || routesPermissao[navPages[1].match])
      return `/interno/home/perfil/config/${clienteId}`;
    if (admPermissao || routesPermissao[navPages[2].match])
      return `/interno/home/perfil/circuito/${clienteId}`;
    if (admPermissao || routesPermissao[navPages[3].match])
      return `/interno/home/perfil/remoteAccess/${clienteId}`;
    if (admPermissao || routesPermissao[navPages[4].match])
      return `/interno/home/perfil/flow/${clienteId}`;
    return `/interno/home/perfil/${clienteId}`;
  };

  // Função que será passada para a Home
  const handleNavigateFromHome = (cliente) => {
    setSelectedCliente(cliente);
    const initialRoute = getFirstAllowedRoute(cliente.id);
    navigate(initialRoute);
  };

  useEffect(() => {
    const currentPath = location.pathname;

    // Encontra o índice da aba na qual a URL atual se encaixa
    const activeTabIndex = navPages.findIndex((page) =>
      currentPath.includes(page.match),
    );

    // Se encontrar a aba e o valor for diferente do estado atual, atualiza
    if (activeTabIndex !== -1 && activeTabIndex !== value) {
      setValue(activeTabIndex);
    }
  }, [location.pathname, navPages, value]);

  useEffect(() => {
    if (selectedCliente) {
      const path = location.pathname;
      let nextPath = path;

      if (path === "/interno/home/perfil" || path === "/interno/home/perfil/") {
        nextPath = getFirstAllowedRoute(selectedCliente?.id);
      } else {
        const { tab: tabInUrl, clienteId: clienteIdInUrl } = parsePerfilUrlParams(path);
        if (clienteIdInUrl && clienteIdInUrl !== selectedCliente?.id) {
          if (tabInUrl) {
            nextPath = `/interno/home/perfil/${tabInUrl}/${selectedCliente?.id}`;
          } else {
            nextPath = `/interno/home/perfil/${selectedCliente?.id}`;
          }
        }
      }

      if (nextPath !== path) {
        navigate(nextPath, { replace: true });
      }

      if (previousClienteIdRef.current !== selectedCliente?.id) {
        setSelectedService(null);
        setConfigStatusFilter("");
        const parsedUrl = parsePerfilUrlParams(location.pathname);
        const preservedServiceId =
          parsedUrl?.clienteId === selectedCliente?.id
            ? parsedUrl?.serviceId
            : null;
        setUrlServiceId(preservedServiceId);
        previousClienteIdRef.current = selectedCliente?.id;
      }

      setClientes((prev) =>
        prev.map((cliente) =>
          cliente?.id === selectedCliente?.id ? selectedCliente : cliente,
        ),
      );
    }
  }, [
    location.pathname,
    navigate,
    selectedCliente,
    admPermissao,
    routesPermissao,
    navPages,
  ]);

  const serviceUrlTabs = useMemo(
    () => ({
      servicos: allService,
      config: allServices,
      circuito: services,
      remoteAccess: allServices,
    }),
    [allService, allServices, services],
  );

  useEffect(() => {
    if (!selectedCliente) return;

    const { tab: tabSegment } = parsePerfilUrlParams(location.pathname);
    if (!tabSegment || !SERVICE_URL_TABS.includes(tabSegment)) return;

    const nextPath = buildTabPath(tabSegment);
    if (nextPath !== location.pathname) {
      navigate(nextPath, { replace: true });
    }
  }, [effectiveServiceId, selectedCliente?.id, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (navigationType !== "POP") return;

    const { serviceId: serviceIdFromUrl, tab: tabSegment } =
      parsePerfilUrlParams(location.pathname);
    if (!serviceIdFromUrl) return;

    const list = serviceUrlTabs[tabSegment];
    if (!list?.length) return;

    const currentSid = selectedService?.id_cliente_servico ?? selectedService?.id;

    if (String(currentSid) === String(serviceIdFromUrl)) return;

    if (urlServiceId && String(urlServiceId) !== String(serviceIdFromUrl) && selectedService) {
      return;
    }

    const match = list.find(
      (service) =>
        String(service?.id_cliente_servico ?? service?.id) ===
        String(serviceIdFromUrl),
    );
    if (match) {
      setSelectedService(match);
    }
  }, [location.pathname, serviceUrlTabs, urlServiceId, navigationType]);
  // ==============================================================================

  return (
    <>
      <Box sx={styles.pageBox}>
        <PerfilFilter
          actionsPermission={handleUsuarioId()}
          admPermissao={admPermissao}
          allHostsCliente={allHostsCliente}
          allService={allService}
          allServices={allServices}
          clientes={clientes}
          configErp={configErp}
          erp={erp}
          erpCliente={erpCliente}
          handleCloseAutocomplete={handleCloseAutocomplete}
          handleForceSync={handleForceSync}
          handleOpenAutocomplete={handleOpenAutocomplete}
          labelErp={labelErp}
          loadingAutocomplete={loadingAutocomplete}
          navigate={navigate}
          openAutocomplete={openAutocomplete}
          openFilter={openFilter}
          options={options}
          paramsSearchCliente={paramsSearchCliente}
          searchAutocomplete={searchAutocomplete}
          searchTerm={searchTerm}
          selectService={selectService}
          selectStatus={selectStatus}
          selectedCliente={selectedCliente}
          selectedHost={selectedHost}
          selectedService={selectedService}
          services={services}
          setOpenFilter={setOpenFilter}
          setOpenModalCreate={setOpenModalCreate}
          setOpenModalCriarGrupo={setOpenModalCriarGrupo}
          setParamsSearchCliente={setParamsSearchCliente}
          setSearchAutocomplete={setSearchAutocomplete}
          setSearchTerm={setSearchTerm}
          setSelectService={setSelectService}
          setSelectStatus={setSelectStatus}
          setSelectedCliente={setSelectedCliente}
          setSelectedHost={setSelectedHost}
          setSelectedService={handleSetSelectedService}
          setServiceFilter={setServiceFilter}
          serviceFilter={serviceFilter}
          showCanceled={showCanceled}
          startSyncAllowed={handleUsuarioId() && value === 1 && selectedCliente}
          statusOptionsUnique={statusOptionsUnique}
          styles={styles}
          syncRunning={syncRunning}
          theme={theme}
          value={value}
          windowWith={windowWith}
          selectedTagFilter={selectedTagFilter}
          setSelectedTagFilter={setSelectedTagFilter}
          availableTags={availableTags}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          configStatusFilter={configStatusFilter}
          setConfigStatusFilter={setConfigStatusFilter}
          tipoClienteFilter={tipoClienteFilter}
          setTipoClienteFilter={setTipoClienteFilter}
          erps={erps}
          erpFilter={erpFilter}
          setErpFilter={setErpFilter}
        />
        {selectedCliente && location.pathname.includes("perfil/") ? (
          <Box sx={styles.container}>
            <Box sx={styles.perfilTabs}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basics tabs config"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                {" "}
                {(admPermissao || routesPermissao[navPages[0].match]) && (
                  <Tab
                    value={0}
                    label={labelErp}
                    {...a11yProps(0)}
                    onMouseDown={(e) =>
                      scrollClicker(e, false, navPages[0].path)
                    }
                  />
                )}
                {(admPermissao || routesPermissao[navPages[1].match]) && (
                  <Tab
                    value={1}
                    label="Configurações"
                    {...a11yProps(1)}
                    onMouseDown={(e) =>
                      scrollClicker(e, false, navPages[1].path)
                    }
                  />
                )}
                {(admPermissao || routesPermissao[navPages[2].match]) && (
                  <Tab
                    value={2}
                    label="Circuito"
                    {...a11yProps(2)}
                    onMouseDown={(e) =>
                      scrollClicker(e, false, navPages[2].path)
                    }
                  />
                )}
                {(admPermissao || routesPermissao[navPages[3].match]) && (
                  <Tab
                    value={3}
                    label="Acesso Remoto"
                    {...a11yProps(3)}
                    onMouseDown={(e) =>
                      scrollClicker(e, false, navPages[3].path)
                    }
                  />
                )}
                {(admPermissao || routesPermissao[navPages[4].match]) && (
                  <Tab
                    value={4}
                    label="Flow"
                    {...a11yProps(4)}
                    onMouseDown={(e) =>
                      scrollClicker(e, false, navPages[4].path)
                    }
                  />
                )}
                {(admPermissao || routesPermissao[navPages[5].match]) && (
                  <Tab
                    value={5}
                    label="Perfil"
                    {...a11yProps(5)}
                    onMouseDown={(e) =>
                      scrollClicker(e, false, navPages[5].path)
                    }
                  />
                )}
              </Tabs>
            </Box>

            <Outlet
              context={{
                setSnackbar,
                selectedCliente,
                // Tipo do ERP do cliente aberto (HUBSOFT, IXC...) e o rótulo
                // do serviço ("Serviço"/"Contrato"). Use no lugar de REACT_APP_ERP.
                erp: erpCliente,
                labelErp,
                setSelectedCliente,
                changed,
                searchTerm,
                setSearchTerm,
                setChanged,
                serviceFilter,
                setServiceFilter,
                services,
                setServices,
                setValue,
                allServices,
                setAllServices,
                selectedService,
                handleSetSelectedService,
                allService,
                setAllService,
                selectService,
                setSelectService,
                selectStatus,
                setSelectStatus,
                allHostsCliente,
                setAllHostsCliente,
                selectedHost,
                setSelectedHost,
                syncRefreshTrigger,
                setSyncRefreshTrigger,
                setIsEditing,
                syncRunning,
                // Recarrega a lista de clientes após salvar/excluir grupo
                // econômico (GrupoEconomicoPerfil) — ao adicionar/remover
                // uma chave deste objeto, atualize também os consumidores
                // via useOutletContext() em 2.1-servicos, 2.2-configuracoes,
                // 2.3-circuito (index.js e circuito/index.js),
                // 2.4-acessoRemoto, 2.5-flow, 2.6-perfil (index.js e
                // GrupoEconomicoPerfil.js)
                apiGetClientes,
                showCanceled,
                setShowCanceled,
                setUrlServiceId,
                urlServiceId,
                configStatusFilter,
                setConfigStatusFilter,
              }}
            />
          </Box>
        ) : (
          <Home
            setRows={setClientes}
            versaoClientes={versaoClientes}
            setSelectedCliente={setSelectedCliente}
            buscarUsuario={buscarUsuario}
            setBuscarUsuario={setBuscarUsuario}
            selectedTagFilter={selectedTagFilter}
            setSelectedTagFilter={setSelectedTagFilter}
            availableTags={availableTags}
            setAvailableTags={setAvailableTags}
            handleNavigateFromHome={handleNavigateFromHome}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            tipoClienteFilter={tipoClienteFilter}
            erpFilter={erpFilter}
          />
        )}
      </Box>

      <CadastroCliente
        openModal={openModalCreate}
        setOpenModal={setOpenModalCreate}
        handleNewClient={handleNewClient}
        setSnackbar={setSnackbar}
      />
      <ModalCriarGrupo
        openModal={openModalCriarGrupo}
        setOpenModal={setOpenModalCriarGrupo}
        setSnackbar={setSnackbar}
        onCreated={() => {
          apiGetClientes();
          setVersaoClientes((v) => v + 1);
        }}
      />
      <Snackbar
        open={!!snackbar}
        onClose={(_, reason) => {
          // Impede o fechamento automático do snackbar com ação (botão Atualizar)
          if (reason === "clickaway") return;
          setSnackbar(null);
        }}
        autoHideDuration={
          snackbar?.autoHideDuration !== undefined
            ? snackbar.autoHideDuration
            : 2500
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert {...snackbar} onClose={() => setSnackbar(null)} />
      </Snackbar>
    </>
  );
}
